import Pay from './pay';
import * as PayTypes from './types';

export { Pay, PayTypes };
export default Pay